import { type FC } from "react";

import clsx from "clsx";

import { SEGMENTS, SEGMENT_LABELS, type Segment } from "./segment_copy";

// Markup transcribed from the design port kit (sections/Segments.html).
export const Segments: FC<{
  segment: Segment;
  onSelect: (segment: Segment) => void;
}> = ({ segment, onSelect }) => (
  <section className="pad" id="who">
    <div className="wrap">
      <h2 className="sec">Designed for every medical-legal professional</h2>
      <div className="chips">
        {SEGMENTS.map((key) => (
          <button
            key={key}
            className={clsx("chip", key === segment && "on")}
            data-seg={key}
            aria-pressed={key === segment}
            onClick={() => onSelect(key)}
          >
            {SEGMENT_LABELS[key]}
          </button>
        ))}
      </div>
    </div>
  </section>
);
